import { Button, Modal } from 'react-bootstrap';

const DeleteConfirmationModal = ({ show, handleClose, handleConfirm, rowData }) => {
  return (
    <Modal show={show} onHide={handleClose} className="modal-delete">
      {rowData && (
        <>
          {/* {rowData?.childAssignment?.length > 0 ? "? It will also delete sub assignment !!" : "?"} */}

          <div className="warning-content">
            <div className="warningOuter">
              <div className="alertImg">
                <img src="../assets/images/delete-record.png" alt="Delete Record"></img>
              </div>
              <div className="warningText">
                {' '}
                Are you sure you want to delete this contact
                <p> {rowData?.fullName}?</p>
              </div>
            </div>
            <div className="notes">
              *Note: Any associated Activities, Visits, Drafts will also be Deleted.
            </div>
            <div className="warningBtn">
              <Button variant="secondary" className="btn" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="btn" variant="danger" onClick={handleConfirm}>
                Confirm Delete
              </Button>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};

export default DeleteConfirmationModal;
